"use strict";

class Answer {


    constructor (private question, private person) {}

    get _rawJSON() {
        return this.person.getAnswerJSON(this.question);
    }

    get value() {
        const answerJson = this._rawJSON;
        if (this.question.type.isMultipleChoice()) {
            return this.question.choices.choiceFromJson(answerJson);
        } else if (this.question.type.isPlaintext()) {
            return answerJson;
        }
        throw new Error("Unknown Question Format");
    }

    get storeValue() {
        const value = this.value;
        if (this.question.type.isMultipleChoice()) {
            return value && value.storeValue;
        } else if (this.question.type.isPlaintext()) {
            return value;
        }
        throw new Error("Unknown Question Format");
    }

    get displayValue() {
        if (this.question.type.isMultipleChoice()) {
            const choice = this._choice;
            return (choice ? this._choice.displayValue : "");
        } else if (this.question.type.isPlaintext()) {
            return this._rawJSON || "";
        }
        throw new Error("Unknown Question Format");
    }

    get _choice() {
        return this.question.choices.choiceFromJson(this._rawJSON);
    }

    displayValueWithContext(evalContext = {}) {
        // user may not have made a choice, may have skipped question
        if (this.question.type.isMultipleChoice() && this._choice) return this._choice.displayValueWithContext(evalContext);
        return this.displayValue;
    }

    get isAnswered() {
        const answerJson = this._rawJSON;
        return !(answerJson === null || answerJson === undefined) ||
               Boolean(this.person.getAnswerTimestamp(this.question));
    }

}

export default Answer;
